export default __webpack_public_path__ + "static/media/cm_1.64bf6ec0.png";